import { lazy, type ComponentType } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import {
  caperTransactionsAccessControl,
  notOnFileRetailerAccessControl,
  inventoryIntelligenceAccessControl,
  staffBarcodeManagementAccessControl,
} from '../access-control/connectedStoresAccess.configuration'
import Toasts from '../toasts'

const ConnectedStoresCaperTransactionsPage = lazy(() => import('../pages/caper-transactions/page'))
const ConnectedStoresCaperTransactionsOrderPage = lazy(
  () => import('../pages/caper-transactions/order/page')
)

// Not on File (Retailer)
const ConnectedStoresNotOnFileRetailerPage = lazy(() => import('../pages/not-on-file-retailer'))
const ConnectedStoresNotOnFileRetailerDetailsPage = lazy(
  () => import('../pages/not-on-file-retailer/details')
)

// Inventory Intelligence
const ConnectedStoresInventoryIntelligencePage = lazy(
  () => import('../pages/inventory-intelligence')
)
const ConnectedStoresInventoryIntelligenceLivePage = lazy(
  () => import('../pages/inventory-intelligence/live')
)
const ConnectedStoresInventoryIntelligenceTrendsPage = lazy(
  () => import('../pages/inventory-intelligence/trends')
)

// Staff Barcode Management
const StaffBarcodeManagementPage = lazy(() => import('../pages/staff-barcode-management/page'))

export const connectedStoresRetailerRouter = (
  <DomainRoute route="app-retailer-scope-connected-stores">
    <Toasts />
    <DashSwitch>
      <DomainRoute
        exact
        route="app-retailer-scope-connected-stores-caper-transactions-order"
        component={ConnectedStoresCaperTransactionsOrderPage as ComponentType<any>}
        accessControl={caperTransactionsAccessControl}
      />
      <DomainRoute
        exact
        route="app-retailer-scope-connected-stores-caper-transactions"
        component={ConnectedStoresCaperTransactionsPage}
        accessControl={caperTransactionsAccessControl}
      />
      <DomainRoute
        exact
        route="app-retailer-scope-connected-stores-not-on-file"
        component={ConnectedStoresNotOnFileRetailerPage as ComponentType<any>}
        accessControl={notOnFileRetailerAccessControl}
      />
      <DomainRoute
        exact
        route="app-retailer-scope-connected-stores-not-on-file-details"
        component={ConnectedStoresNotOnFileRetailerDetailsPage as ComponentType<any>}
        accessControl={notOnFileRetailerAccessControl}
      />
      <DomainRoute
        exact
        route="app-retailer-scope-connected-stores-inventory-intelligence-live"
        component={ConnectedStoresInventoryIntelligenceLivePage as ComponentType<any>}
        accessControl={inventoryIntelligenceAccessControl}
      />
      <DomainRoute
        exact
        route="app-retailer-scope-connected-stores-inventory-intelligence-trends"
        component={ConnectedStoresInventoryIntelligenceTrendsPage as ComponentType<any>}
        accessControl={inventoryIntelligenceAccessControl}
      />
      <DomainRoute
        exact
        route="app-retailer-scope-connected-stores-inventory-intelligence"
        component={ConnectedStoresInventoryIntelligencePage as ComponentType<any>}
        accessControl={inventoryIntelligenceAccessControl}
      />
      <DomainRoute
        exact
        route="app-retailer-scope-connected-stores-staff-barcode-management"
        component={StaffBarcodeManagementPage}
        accessControl={staffBarcodeManagementAccessControl}
      />
    </DashSwitch>
  </DomainRoute>
)
